export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">关于小小影院</h2>
          <p className="text-foreground-600 text-sm">专注高清免费影视的在线观影平台</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="space-y-5">
            <p className="text-foreground-700 leading-relaxed">
              小小影院诞生于影迷对高品质观影体验的追求。我们深知在这个内容付费的时代，
              依然有无数热爱影视的观众需要一片自由、高清、无门槛的观影天地。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              自上线以来，我们始终坚持三大原则：<strong>高清画质</strong>不妥协、
              <strong>播放流畅</strong>不缓冲、<strong>无需注册</strong>不设限。
              目前站内已收录 <span className="text-primary-500 font-semibold">32,000+</span> 部高清影视资源，
              日均服务超过 <span className="text-primary-500 font-semibold">120万</span> 位影迷朋友。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              未来，我们将持续扩大片库覆盖面，优化播放体验，让每一位来到小小影院的观众
              都能找到心仪的好剧好片，享受最纯粹的观影乐趣。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {[
              { num: '32,000+', label: '高清片源' },
              { num: '50+', label: '日均更新' },
              { num: '120万+', label: '日均访客' },
              { num: '1080P', label: '超清画质' },
            ].map((stat) => (
              <div key={stat.label} className="p-5 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="text-2xl font-bold text-primary-500 mb-1">{stat.num}</div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}